//loyaltyPerPaymentMethodReportController
(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("changerIncomeByDateController", changerIncomeByDateController);

  /** @ngInject */
  function changerIncomeByDateController(
    $scope,
    $translate,
    reportExportUtil,
    exportToCsv,
    ChangerIncomeByDateViewModel,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;

    vm.report = new ChangerIncomeByDateViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = "TOKENS_TITLE";

    init();

    function init() {
      $scope.$on("$destroy", destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant("DATE"),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER,
        vm.namingData
      );

      exportToCsv.export(
        jsonArrayForExport,
        $translate.instant("CHANGER_INCOME"),
        true
      );
    }
  }
})();
